export function getClientId() {
  let id = localStorage.getItem("ws_client_id");
  if (!id) {
    id = "c_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("ws_client_id", id);
  }
  return id;
}
